import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from "vue-property-decorator";
import DashboardBoardWidget from "@/components/DashboardBoardWidget.vue";
let DashboardBoardsWidget = class DashboardBoardsWidget extends Vue {
    get boardStatsPerRows() {
        const boardStatsPerRows = new Array();
        for (const [index, boardStats] of this.boardStats.entries()) {
            if (index % 2 == 0) {
                boardStatsPerRows.push([]);
            }
            boardStatsPerRows[boardStatsPerRows.length - 1].push(boardStats);
        }
        return boardStatsPerRows;
    }
};
__decorate([
    Prop({ type: Array, required: true })
], DashboardBoardsWidget.prototype, "boardStats", void 0);
__decorate([
    Prop({ type: Number, required: true })
], DashboardBoardsWidget.prototype, "usersCount", void 0);
DashboardBoardsWidget = __decorate([
    Component({
        components: { DashboardBoardWidget }
    })
], DashboardBoardsWidget);
export default DashboardBoardsWidget;
